import { NumberFormatter, Progress } from '@mantine/core'
import classes from './StatWithIndicator.module.css'
import clsx from 'clsx'
import { Typography } from '../../common/typography'

export default function StatWithIndicator({
  title,
  value,
  progress,
  hideProgressBar,
  subtitle,
  progressColor,
}: {
  title: string
  value: string | number
  progress?: number
  hideProgressBar?: boolean
  subtitle?: React.ReactNode
  progressColor?: string
}) {
  const isValueNumber = typeof value === 'number'
  const progressValue = progress != null ? progress : isValueNumber ? value : 0
  return (
    <div className={classes.container}>
      <Typography fw={500} lh="130">
        {title}
      </Typography>
      {isValueNumber ? (
        <NumberFormatter
          className={classes.value}
          decimalScale={2}
          fixedDecimalScale
          suffix="%"
          value={value}
        />
      ) : (
        <span className={classes.value}>{value}</span>
      )}
      {subtitle && <>{subtitle}</>}
      <Progress
        classNames={{
          root: clsx(classes.root, { [classes.hidden]: hideProgressBar }),
          section: progressColor
            ? undefined
            : clsx({
                [classes.section_red]: progressValue < 50,
                [classes.section_orange]:
                  progressValue >= 50 && progressValue < 75,
                [classes.section_green]: progressValue >= 75,
              }),
        }}
        style={{ '--progress': progressColor }}
        value={progressValue}
        color={progressColor}
      />
    </div>
  )
}
